export enum TimeSlotType {
    Session,
    FreeSlot,
    SelectedSlots
}
